<template>
  <VModal
      :title="slider.name ? 'ویرایش اسلایدر ' + slider.name : 'ایجاد اسلایدر'"
      :show="show">

    <VAlert class="mt-4" type="danger" v-if="errors.length > 0">
      <div v-for="(error, index) in errors"
           :key="error" :class="{'font-bold' : index === 0}">
        {{ index !== 0 ? '- ' + error : error }}
      </div>
    </VAlert>

    <form @submit.prevent="submit" ref="form">
      <input type="hidden" name="_method" value="PUT" v-if="slider.name">

      <div class="mt-5">
        <VImageInput :photo="slider.photo ? slider.photo.path : ''"/>
      </div>

      <div class="mt-5">
        <label>نام</label>
        <VInput type="text" name="name" :value="slider.name" placeholder="نام اسلایدر" class="mt-4" required/>
      </div>

      <div class="flex items-center justify-between mt-8">
        <div>
          <label>وضعیت اسلایدر</label>
          <h6 class="mt-1 text-sm text-muted">در صورت غیرفعال بودن اسلایدر، اسلایدر نمایش داده نمیشود</h6>
        </div>

        <VSwitch v-model="active" :value="slider.active"/>
      </div>

      <VButton type="submit" class="mt-10 w-full">ثبت</VButton>

      <VLoadingScreen :show="loading" />
    </form>

  </VModal>
</template>

<script>
import VModal from "@/components/General/VModal";
import VInput from "@/components/General/VInput";
import VSwitch from "@/components/General/VSwitch";
import VButton from "@/components/General/VButton";
import VImageInput from "@/components/General/VImageInput";
import {createSlider, updateSlider} from "@/API/API";
import VAlert from "@/components/General/VAlert";
import VLoadingScreen from "@/components/General/VLoadingScreen";

export default {
  name: "ModalSlider",
  components: {VLoadingScreen, VAlert, VImageInput, VButton, VSwitch, VInput, VModal},
  props: {
    show: Boolean,
    slider: {
      default: () => ({})
    }
  },
  data() {
    return {
      image: '',
      active: 1,
      loading: false,
      errors: [],
    }
  },
  methods: {
    submit() {
      this.loading = true
      this.errors = []

      let slider = new FormData(this.$refs.form)
      slider.append('active', this.active)

      if (this.slider.name) {
        this.updateSlider(slider)
      } else {
        this.createSlider(slider)
      }
    },
    updateSlider(slider) {
      updateSlider(this.slider.id, slider)
          .then(resp => this.$emit('edited', resp.data))
          .catch(err => this.$helper.validationError(err, this.errors))
          .finally(() => this.loading = false)
    },
    createSlider(slider) {
      createSlider(slider)
          .then(resp => this.$emit('created', resp.data))
          .catch(err => this.$helper.validationError(err, this.errors))
          .finally(() => this.loading = false)
    }
  }

}
</script>

<style scoped>

</style>